import { render, staticRenderFns } from "./FactFindPolicies.vue?vue&type=template&id=357df506&"
import script from "./FactFindPolicies.vue?vue&type=script&lang=ts&"
export * from "./FactFindPolicies.vue?vue&type=script&lang=ts&"
import style0 from "./FactFindPolicies.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports